import { Typography } from '@mui/material'
import { FormText } from './FormText'

export function FormTextPrint (props) {
  return (
    <Typography className='form-read-only-text'>
      <FormText {...props} />
    </Typography>
  )
}
